import { Card, Spin } from 'antd';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageHeader from './PageHeader';
import type { AdminPageWidth } from './AdminListPage';
import {
  resolveAdminBreadcrumbs,
  type AdminBreadcrumbItem,
} from '../utils/adminBreadcrumbs';

export interface AdminSectionPageProps {
  title: string;
  subtitle?: string;
  extra?: ReactNode;
  loading?: boolean;
  children?: ReactNode;
  bare?: boolean;
  widthMode?: AdminPageWidth;
  breadcrumbs?: AdminBreadcrumbItem[];
  densityOps?: boolean;
}

export function AdminSectionPage({
  title,
  subtitle,
  extra,
  loading = false,
  children,
  bare = false,
  widthMode = 'canvas',
  breadcrumbs,
  densityOps,
}: AdminSectionPageProps) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const crumbs = breadcrumbs ?? resolveAdminBreadcrumbs(location.pathname, t);
  void i18n.language;
  const useOpsDensity =
    densityOps ?? (bare || widthMode === 'fluid' || widthMode === 'fluid-bleed');
  const rootClass = [
    'admin-section-page',
    `admin-page--${widthMode}`,
    useOpsDensity ? 'admin-page--density-ops' : '',
  ]
    .filter(Boolean)
    .join(' ');

  if (loading) {
    return (
      <div className={rootClass}>
        <PageHeader title={title} subtitle={subtitle} extra={extra} breadcrumbs={crumbs} />
        <div className="admin-section-page__loading">
          <Spin size="large" />
        </div>
      </div>
    );
  }

  return (
    <div className={rootClass}>
      <PageHeader title={title} subtitle={subtitle} extra={extra} breadcrumbs={crumbs} />
      {bare ? children : <Card className="admin-section-card" bordered={false}>{children}</Card>}
    </div>
  );
}

export default AdminSectionPage;
